import { render, staticRenderFns } from "./DenyOrderForm.vue?vue&type=template&id=593a0974&scoped=true&"
import script from "./DenyOrderForm.vue?vue&type=script&lang=js&"
export * from "./DenyOrderForm.vue?vue&type=script&lang=js&"
import style0 from "./DenyOrderForm.vue?vue&type=style&index=0&id=593a0974&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "593a0974",
  null
  
)

export default component.exports